import * as yup from 'yup'

export const SingUiSchema = yup.object().shape({
  full_name: yup
    .string()
    .required(
      'This field is required',
    ),
  email: yup
    .string()
    .email('Enter a valid email address')
    .required(
      'This field is required',
    ),
  password: yup
    .string()
    .min(8, 'Password must be at least 8 characters')
    .matches(/\d/, 'Password must include at least one number')
    .required(
      'This field is required',
    )
})